module.exports = __webpack_public_path__ + "img/tuihao.f883c1b7.png";